import React, { useRef, useState, useEffect } from 'react';
import PreviewCompatibleImage from '../PreviewCompatibleImage';
import Carousel from '@itseasy21/react-elastic-carousel';

const testimonials = [
  {
    image: '/img/clients/educause.png',
    client: 'Educause',
    quote: "“There was a particular moment in my cyber security journey where I needed a strong security company to engage with and drive much necessary change. Cypress understood the risks and the optics challenges and helped drive momentum with our leadership. I can not endorse them strong enough.There was a particular moment in my cyber security journey where I needed a strong security company to engage with and drive much necessary change. Cypress understood the risks and the optics challenges and helped drive momentum with our leadership. I can not endorse them strong enough..”"
  },
  {
    image: '/img/clients/shift.png',
    client: 'Accompany.io',
    quote: "“We ran our first ever PEN test with Cypress, who were recommended by a security expert that we knew. They provided a clear process, did a great assessment and helped us understand how we would remediate the issues that were raised. Three months later we had them re-test, and got the all clear. The clarity of their report helped us get there so quickly. We'll keep using them as we scale.”"
  },
  {
    image: '/img/brands/arrt.png',
    client: 'ARRT (American Registry of Radiologic Technologists)',
    quote: "Working with Cypress Data Defense has been an absolute pleasure every step of the way. From their world class training to assistance with our Secure SDLC process to a thorough hybrid penetration test they helped us implement security every step of the way."
  },
  {
    image: '/img/clients/bluecompass.png',
    client: 'Blue Compass',
    quote: '“Blue Compass engaged Cypress Data Defense to ensure our development process continues to be secure in this ever-changing landscape. Cypress Data Defense provided an implementation plan to our development and network people and after many conversations back-and-forth, we have a great security foundation. We look forward to working with Cypress Data Defense on additional plans in the future."'
  }
];

export default () => {
  if (typeof window === 'undefined') return null;

  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const goToPrevSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.slidePrev();
    }
  };

  const goToNextSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.slideNext();
    }
  };

  const goToSlide = (index) => {
    if (carouselRef.current) {
      carouselRef.current.goTo(index);
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.onChange = (currentItem, pageIndex) => {
        setActiveIndex(pageIndex);
      };
    }
  }, []);

  return (
    <section className="section dark-bg testimonial-section">
      <div className="container custom-slider">
        <h2>WHAT OUR CLIENTS SAY</h2>

        <Carousel
          ref={carouselRef}
          showArrows={false}
          pagination={false}
          infinite
          onChange={(currentItem, pageIndex) => setActiveIndex(pageIndex)}
        >
          {testimonials.map((el, i) => (
            <div className="darker-bg testimonial-title" key={i}>
              <div className="carousel__img">
                <PreviewCompatibleImage imageInfo={el} />
              </div>
              <div className="testimonial-author">{el.client}</div>
              <div className="testimonial-text">{el.quote}</div>
            </div>
          ))}
        </Carousel>

        <div className="carousel-controls">
          <button id="prevBtn" className="carousel__btn" onClick={goToPrevSlide}>←</button>
          <div className="custom-dots">
            {testimonials.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === activeIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              ></span>
            ))}
          </div>
          <button id="nextBtn" className="carousel__btn" onClick={goToNextSlide}>→</button>
        </div>
      </div>
    </section>
  );
};
